import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';
import LoadingButton from '@mui/lab/LoadingButton';
import ValidationFeedback from '../components/validation.feedback';

import GoogleSheetsService from '../service/googlesheet.service';

const GetMemberForm = ({ updateMember, memberSearchRef, required, label, autoFocus }) => {
    const [memberNo, setMemberNo] = useState('');
    const [searchingMember, setSearchingMember] = useState(false);
    const [memberError, setMemberError] = useState('');

    const searchMember = () => {
        if (searchingMember === false) {
            setSearchingMember(true);
            GoogleSheetsService.searchMember(memberNo).then((result) => {
                updateMember(result);
                setMemberError('');
                if (!result) {
                    setMemberError('Ingen medlem kunde hittas med det angivna kundnumret');
                    setTimeout(() => {
                        setMemberError('');
                    }, 10000);
                }
                setSearchingMember(false);
            });
        }
    }

    const getMemberButtonText = () => {
        if (searchingMember) {
            return "Söker efter medlem";
        } else {
            return "Hämta medlem";
        }
    }

    return (
        <React.Fragment>
            <div className='s4g-section s4g-member'>
                <div>
                    <TextField required={required}
                        id="s4g-memberno"
                        label={label}
                        sx={{ width: '100%;' }}
                        value={memberNo}
                        autoFocus={autoFocus}
                        onChange={e => setMemberNo(e.target.value)}
                        onKeyUp={e => {
                            if (e.keyCode === 13) {
                                searchMember();
                            }
                        }} />
                </div>
                <div className='s4g-member-button'>
                    <LoadingButton
                        loading={searchingMember}
                        variant="contained"
                        loadingPosition="start"
                        ref={memberSearchRef}
                        startIcon={<SearchIcon />}
                        onClick={searchMember}>
                        {getMemberButtonText()}
                    </LoadingButton>
                </div>

            </div>
            <ValidationFeedback validationError={memberError} />
        </React.Fragment>
    )
}

export default GetMemberForm;
